interface ClarifyEntriesIconProps {
  size?: number
  className?: string
}

export const ClarifyEntriesIcon = ({ size = 16, className = '' }: ClarifyEntriesIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clarify-entries-clip)">
      <path
        d="M1.33 6V3.33C1.33 2.98 1.47 2.64 1.72 2.39C1.97 2.14 2.31 2 2.67 2H5.27C5.49 2 5.71 2.05 5.91 2.16C6.1 2.26 6.27 2.41 6.39 2.6L6.93 3.4C7.05 3.58 7.22 3.74 7.41 3.84C7.61 3.95 7.83 4 8.05 4H13.33C13.69 4 14.03 4.14 14.28 4.39C14.53 4.64 14.67 4.98 14.67 5.33V12C14.67 12.35 14.53 12.69 14.28 12.94C14.03 13.19 13.69 13.33 13.33 13.33H2.67C2.31 13.33 1.97 13.19 1.72 12.94C1.47 12.69 1.33 12.35 1.33 12V11.33"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33 8.67H8"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10.67L8 8.67L6 6.67"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clarify-entries-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
